export default "__VITE_ASSET__5260b524__"